module.exports = [{
      plugin: require('/home/travis/build/gicmadev/gicma.dev/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":2048},
    }]
